import { extend } from 'vee-validate';
import i18next from 'i18next';
import { formatCurrency } from '@/core/currency/helpers';

extend('less_than', {
    validate(value, { actualValue, max }:any) {
        try {
            return (actualValue <= max);
        } catch (e) {
            return false;
        }
    },
    params: ['actualValue', 'max', 'currency'],
    message: (_, { max, currency }) => i18next.t('errors:less_than', { currencySymbol: currency.symbol, amount: formatCurrency(max, currency.format, '0,0.00') })
});
